import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';

class FixSales extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        showFixSalesRef: false,
    };

    qrcodeRef = React.createRef();
    fixSalesRef = React.createRef();

    handleScroll = () => {
        const scrollTop = document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        // const documentHeight = document.documentElement.scrollHeight;

        if (scrollTop > 2 * windowHeight) {
            this.setState({ showFixSalesRef: true });
        } else {
            this.setState({ showFixSalesRef: false });
        }
      };

    componentDidMount() {
        const { content } = this.props;
        const qrcodeImage = content.qrcodeImage || '';

        if (qrcodeImage) {
            const canvasDom = document.getElementById('qrcodeImage');

            canvasDom.style.display = 'block';

            // canvasDom插入到qrcodeRef元素中
            this.qrcodeRef.current.appendChild(canvasDom);
        }

        window.addEventListener('scroll', this.handleScroll);
        // fixSalesRef 超过两屏展示浮层，否则不展示
            
    }

    render() {
        const { content } = this.props;
        const { showFixSalesRef } = this.state;
        const thumbnail = content?.qrcodeBrand;
        const fixedService = content?.fixedService?.image;
        const noQrcodeImage = content?.fixedService?.noQrcode;
        const qrcodeImage = content.qrcodeImage || '';

        return (
            <div className={styles.fixSales} style={{ display: showFixSalesRef ? 'block' : 'none' }}>
                {qrcodeImage && <div className={styles.fixSalesContent}>
                    <div className={styles.fixSalesLeft}>
                        <div className={styles.fixSalesText}>微信扫码购买</div>
                        <div className={styles.fixSalesQrcode} ref={this.qrcodeRef}>
                            {/* <canvas className={styles.fixSalesQrcodePic} width="440" height="440" /> */}
                        </div>
                    </div>
                    {thumbnail && <div className={styles.fixSalesRight}>
                        <img className={styles.fixSalesPic} src={formatImage(thumbnail, 154, 137)} />
                    </div>}
                </div>}
                <img className={styles.fixSalesBrand} src={qrcodeImage ? fixedService : noQrcodeImage} />
            </div>
        );
    }
}

export default errorBoundary(FixSales);
